import React from "react";
import { Typography } from "antd";
import styles from "./locked-sidebar.css";

const { ["container"]: containerClassName } = styles;

export const LockedSidebar = () => {
  return (
    <div className={containerClassName}>
      <Typography.Text>
        Complete the <strong>Client &amp; Matter Details tab</strong> and{" "}
        <strong>Pricing Structure tab</strong> to get started.
      </Typography.Text>
    </div>
  );
};
